// extracted by mini-css-extract-plugin
export default {"centerdiv":"ADLoginLoading_centerdiv__pX1Rf","bounce":"ADLoginLoading_bounce__3p8QJ","loading-message":"ADLoginLoading_loading-message__sQ65v"};